import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ModalPdfComponent } from '../modal-pdf/modal-pdf.component';

export interface MyDataSource {
  producto: string;
  descripcion: string;
  stockbultos: number;
  ubicacion: string;
  seleccionar: boolean;
  orden: number;
}

const MY_DATA: MyDataSource[] = [
  {producto: 'NP-00324363', descripcion: 'LIMA PARA CUCHILLO RAYADA', stockbultos: 25, ubicacion: 'Rack A1', seleccionar: false, orden: 0},
  {producto: 'NP-00324364', descripcion: 'BROCHA MANGO PLASTICO BRP', stockbultos: 15, ubicacion: 'Rack K2', seleccionar: true, orden: 15},
  {producto: 'NP-00324365', descripcion: 'CUBO ESPIGA DE 1/2 P/BUJIA', stockbultos: 2, ubicacion: 'Rack F1', seleccionar: false, orden: 0},
  {producto: 'NP-00324366', descripcion: 'SILICON PLOURETANO UNECOL', stockbultos: 18, ubicacion: 'Rack X2', seleccionar: false, orden: 0},
  {producto: 'NP-00324368', descripcion: 'BOMBA SUMERGIBLE AGUA LIMPIA', stockbultos: 30, ubicacion: 'Rack X2', seleccionar: false, orden: 0},
  {producto: 'NP-00324369', descripcion: 'ANTENA AEREA P/EXTERIOR', stockbultos: 10, ubicacion: 'Rack X3', seleccionar: false, orden: 0}
];


@Component({
  selector: 'app-exit-order',
  templateUrl: './exit-order.component.html',
  styleUrls: ['./exit-order.component.scss']
})
export class ExitOrderComponent implements OnInit {
  displayedColumns: string[] = ['producto', 'descripcion', 'stockbultos', 'piezas', 'ubicacion', 'seleccionar', 'orden'];
  dataSource = MY_DATA;
  selectedTab: number;

  totalPieces = 100;

  constructor(public dialog: MatDialog) { }

  ngOnInit() { }

  onOrderExit(): void {
    this.openDialog();
  }

  private openDialog(): void {
      const dialogRef = this.dialog.open(ModalPdfComponent, {
          height: '600px',
          width: '600px',
          data: { title: 'Orden de salida', url: '/assets/pdf/OrdenSalida.pdf' }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
  }

  onNext(): void {
    if (this.selectedTab === 1) {
      this.selectedTab = 0;
    }
    this.selectedTab = 1;
  }

  onClickTab(): void {
    this.selectedTab = 0;
  }

}
